import React, { useState } from 'react';
import './policy-number-modal.scss';

interface PolicyNumberModalProps {
  isOpen: boolean;
  policyNumber: string;
  title?: string;
  message?: string;
  onConfirm: () => void;
  onCopy?: () => void;
}

export default function PolicyNumberModal({
  isOpen,
  policyNumber,
  title = 'رقم الوثيقة',
  message = 'تم إصدار الوثيقة بنجاح. يرجى حفظ رقم الوثيقة:',
  onConfirm,
  onCopy,
}: PolicyNumberModalProps) {
  const [copied, setCopied] = useState(false);
  const isLink = /^https?:\/\//i.test(policyNumber);

  if (!isOpen) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(policyNumber).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      if (onCopy) {
        onCopy();
      }
    }).catch((err) => {
      console.error('Failed to copy:', err);
    });
  };

  const handleDownload = () => {
    const blob = new Blob([policyNumber], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `policy_number_${policyNumber}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="policy-number-modal-overlay">
      <div className="policy-number-modal">
        <div className="policy-number-modal-header">
          <h2>{title}</h2>
        </div>

        <div className="policy-number-modal-content">
          <p className="message">{message}</p>
          
          <div className="policy-number-display">
            <div className="policy-number-label">{isLink ? "الرابط:" : "رقم الوثيقة:"}</div>
            <div className="policy-number-value">
              {isLink ? (
                <a href={policyNumber} target="_blank" rel="noopener noreferrer">
                  {policyNumber}
                </a>
              ) : (
                policyNumber
              )}
            </div>
          </div>

          <div className="action-buttons">
            <button
              className="btn-copy"
              onClick={handleCopy}
            >
              {copied ? (
                <>
                  <span className="material-symbols-outlined">check</span>
                  تم النسخ
                </>
              ) : (
                <>
                  <span className="material-symbols-outlined">content_copy</span>
                  نسخ الرقم
                </>
              )}
            </button>
            {!isLink && (
              <button
                className="btn-download"
                onClick={handleDownload}
              >
                <span className="material-symbols-outlined">download</span>
                حفظ الملف
              </button>
            )}
            {isLink && (
              <a
                className="btn-open-link"
                href={policyNumber}
                target="_blank"
                rel="noopener noreferrer"
              >
                افتح الرابط
              </a>
            )}
          </div>
        </div>

        <div className="policy-number-modal-footer">
          <button
            className="btn-confirm"
            onClick={onConfirm}
          >
            تم الحفظ والتأكيد
          </button>
        </div>
      </div>
    </div>
  );
}

